import L from "leaflet";
import searchService from "../services/searchService";
import { Place } from "@/types/common";
import collegegreen from "../assets/collegegreen.png";
import collegeyellow from "../assets/collegeyellow.png";
import collegegrey from "../assets/collegegrey.png";
import collegered from "../assets/collegered.png";

export const createImageIcon = (imageUrl: string): L.Icon => {
  return L.icon({
    iconUrl: imageUrl,
    iconSize: [40, 40],
    iconAnchor: [20, 40],
    popupAnchor: [0, -30],
  });
};

export const createTextIcon = (name: string, show: boolean, customColor: string): L.DivIcon => {
  if (!show) {
    return L.divIcon({
      html: `<div style="display: none;"></div>`,
      className: "text-marker",
      iconSize: [0, 0],
      iconAnchor: [0, 0],
    });
  }
  const displayName = name.length > 15 ? name.substring(0, 15) + "..." : name;
  return L.divIcon({
    html: `<div style="
      font-size: 18px;
      font-weight: 500;
      color: ${customColor};
      white-space: nowrap;
      cursor: pointer;
      z-index: 1000;
      position: relative;
      line-height: 1;
      text-shadow: 2px 2px 4px rgba(255,255,255,0.8);
    ">${displayName}</div>`,
    className: "text-marker",
    iconSize: [0, 0],
    iconAnchor: [0, 0],
    popupAnchor: [0, 0],
  });
};

export const getCategoryIconUrl = (placeData: Place, type: string) => {
  if (!placeData) {
    switch (type) {
      case "green": return collegegreen;
      case "yellow": return collegeyellow;
      case "red": return collegered;
      case "gray": return collegegrey;
      default: return collegegrey;
    }
  }
  const category = placeData.category || "default";
  const subcategory = placeData.subcategory || "default";
  const accessibility = placeData.accessibility || "no_data";

  return searchService.getCategoryIcon(category, subcategory, accessibility);
};
